// @flow

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Header from './Header';

const mapStateToProps = state => ({
  isDarkTheme: state.app.isDarkTheme,
});

export default withRouter(connect(mapStateToProps)(Header));



// WEBPACK FOOTER //
// ./src/view/screens/Header/index.js